
import WebService from "../../WebService"


const Sponsor = {
    gets(params) {
        return WebService.get("/console/contest/sponsors?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/sponsors/" + id + '?e=' + e)
    },
    create(data) {
        return WebService.post("/console/contest/sponsors", data)
    },
    update(data) {
        return WebService.post("/console/contest/sponsors/" + data.sponsor_id, data)
    },
    upload(id, data) {
        return WebService.post("/console/contest/sponsors/" + id, data)
    }
}
export default Sponsor